import numericInput from '../lib/numericInput';

export default (value, fallbackValue) => {
  let defaultValue = fallbackValue;
  if (defaultValue === undefined) {
    defaultValue = value;
  }
  const ensured = value === undefined ? defaultValue : value;
  return {
    inputDisplay: numericInput.format(value, { autoDecimal: true }),
    input: value,
    defaultDisplay: numericInput.format(defaultValue, { autoDecimal: true }),
    default: defaultValue,
    ensured,
    ensuredDisplay: numericInput.format(ensured, { autoDecimal: true }),
  };
};
